import { Component, OnInit } from '@angular/core';

import { AuthService } from '../auth.service';
import { AuthUser } from './auth-user.model';
import { IFrame } from './iframe.model';
import { Observable } from 'rxjs';


@Component({
  selector: 'app-auth-frame',
  templateUrl: './auth-frame.component.html',
  styleUrls: ['./auth-frame.component.css']
})
export class AuthFrameComponent implements OnInit {

  authUser: AuthUser;
  frameList: Array<IFrame>;
  authSubject: Observable<AuthUser>;
  iFrameLoaded: boolean = false;

  constructor(private authService: AuthService) { }

  ngOnInit() {
    this.authSubject = this.authService.getAuthModel();
    this.authSubject.subscribe((user: AuthUser) => {

      if (!this.iFrameLoaded) {
        this.authUser = user;
        let frames: string = '';

        this.getFrameLinks().forEach(f => {
          frames = frames + '<iframe id="' + f.name + '" src="' + f.link + '" width="400" height="400" class="hidden"></iframe>';
        });

        document.querySelector("#frame-container").innerHTML = frames;
        this.iFrameLoaded = true;
      }
    });
  }

  getFrameLinks(): Array<any> {

    if (this.authUser)
      return this.authUser.listIframe;

    return new Array<any>();
  }
}
